import * as React from 'react';
import { MobXProviderContext } from 'mobx-react';

export const useStores = (): any => React.useContext(MobXProviderContext);